var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cn-divider",class:{ 'cn-divider--light': _vm.light },attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"cn-divider__line"}),_c('span',{staticClass:"cn-divider__icon"},[_vm._v("◈")]),_c('span',{staticClass:"cn-divider__line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }